import {BrandInfo} from "@/lib/queries/accounts.ts";
import {ServiceUsage} from "@/lib/types/checks.ts";
import {InstantCheckoutContainer} from "@/pages/checks/components/form/InstantCheckout/InstantCheckoutContainer.tsx";
import {InstantCheckoutPurchaseFailure} from "@/pages/checks/components/form/InstantCheckout/InstantCheckoutPurchaseFailure.tsx";
import {InstantCheckoutRequestFailure} from "@/pages/checks/components/form/InstantCheckout/InstantCheckoutRequestFailure.tsx";

interface InstantCheckoutFailureProps {
  userCanPurchase: boolean;
  serviceUsage: ServiceUsage;
  brand: BrandInfo;
}

export const InstantCheckoutFailure = ({userCanPurchase, serviceUsage}: InstantCheckoutFailureProps) => (
  <InstantCheckoutContainer
    message={
      userCanPurchase ? (
        <InstantCheckoutPurchaseFailure serviceUsage={serviceUsage} />
      ) : (
        <InstantCheckoutRequestFailure serviceUsage={serviceUsage} />
      )
    }
  />
);
